export const Types = {
	STORE_MARKET_LIST: 'STORE_MARKET_LIST',
	STORE_BRAND_LIST: 'STORE_BRAND_LIST',
	STORE_CATEGORY_LIST: 'STORE_CATEGORY_LIST',
	STORE_COLLECTION_LIST: 'STORE_COLLECTION_LIST',
	STORE_ROLE_BASED_COLLECTION_LIST: 'STORE_ROLE_BASED_COLLECTION_LIST',
	STORE_SEASON_LIST: 'STORE_SEASON_LIST',
	STORE_FABRIC_LIST: 'STORE_FABRIC_LIST',
	STORE_MATERIAL_LIST: 'STORE_MATERIAL_LIST',
	STORE_INITIAL_ITEM_IN_GLOBAL_FILTER: 'STORE_INITIAL_ITEM_IN_GLOBAL_FILTER',
	STORE_ITEM_IN_GLOBAL_FILTER: 'STORE_ITEM_IN_GLOBAL_FILTER',
	UPDATE_TEXT_ITEM_IN_GLOBAL_FILTER: 'UPDATE_TEXT_ITEM_IN_GLOBAL_FILTER',
	UPDATE_TEXT_ITEM_MULTIPLE_IN_GLOBAL_FILTER: 'UPDATE_TEXT_ITEM_MULTIPLE_IN_GLOBAL_FILTER',
	REMOVE_ITEM_FROM_GLOBAL_FILTER: 'REMOVE_ITEM_FROM_GLOBAL_FILTER',
	CLEAR_GLOBAL_FILTER: 'CLEAR_GLOBAL_FILTER',
	CLEAR_GLOBAL_FILTER_WITH_EXCLUDE: 'CLEAR_GLOBAL_FILTER_WITH_EXCLUDE',
	CLEAR_GLOBAL_FILTER_WITH_DATE: 'CLEAR_GLOBAL_FILTER_WITH_DATE',
	CLEAR_GLOBAL_FILTER_SELECTED_FIELDS: 'CLEAR_GLOBAL_FILTER_SELECTED_FIELDS',
	FETCH_GLOBAL_FILTER_DATA: 'FETCH_GLOBAL_FILTER_DATA',
	ADD_ITEM_IN_GLOBAL_FILTER_DATA: 'ADD_ITEM_IN_GLOBAL_FILTER_DATA',
	UPDATE_GLOBAL_FILTER_DATA: 'UPDATE_GLOBAL_FILTER_DATA',
	REMOVE_ITEM_FROM_FILTER_RESPONSE: 'REMOVE_ITEM_FROM_FILTER_RESPONSE',
	STORE_USER_LIST: 'STORE_USER_LIST',
	TOGGLE_GLOBAL_FILTER: 'TOGGLE_GLOBAL_FILTER',
	CLEAR_GLOBAL_FILTER_RESPONSE: 'CLEAR_GLOBAL_FILTER_RESPONSE',
	UPDATE_DESIGN_INFO_SUCCESS: 'UPDATE_DESIGN_INFO_SUCCESS',
	UPLOAD_DESIGN_TOOL_DOCUMENT: 'UPLOAD_DESIGN_TOOL_DOCUMENT',
	FETCH_DESIGN_INFO: 'FETCH_DESIGN_INFO',
	DELETE_DESIGN_TOOL_DOCUMENT: 'DELETE_DESIGN_TOOL_DOCUMENT',
	STORE_ART_BOARD: 'STORE_ART_BOARD',
	FETCH_ART_BOARD: 'FETCH_ART_BOARD',
	UPDATE_ART_BOARD: 'UPDATE_ART_BOARD',
	DELETE_ART_BOARD: 'DELETE_ART_BOARD',
	FETCH_TECHPACK: 'FETCH_TECHPACK',
	FETCH_DESIGN_TOOL_COMMENT: 'FETCH_DESIGN_TOOL_COMMENT',
	FETCH_DESIGN_TOOL_MEMBERS: 'FETCH_DESIGN_TOOL_MEMBERS',
	FETCH_PRODUCT_WISE_DOCUMENT: 'FETCH_PRODUCT_WISE_DOCUMENT',
	FETCH_ALL_SAMPLE_BY_STATUS: 'FETCH_ALL_SAMPLE_BY_STATUS',
	SET_SAMPLE_REQUEST_FILTER_DATA: 'SET_SAMPLE_REQUEST_FILTER_DATA',
	SET_SAMPLE_REQUEST_COUNT: 'SET_SAMPLE_REQUEST_COUNT',
	OPEN_LOADER: 'OPEN_LOADER',
	CLOSE_LOADER: 'CLOSE_LOADER',
	FETCH_SAMPLE_PRODUCTS: 'FETCH_SAMPLE_PRODUCTS',
	FETCH_SAMPLE_BY_ID: 'FETCH_SAMPLE_BY_ID',
	SET_SAMPLE_VIEW_FILTER_DATA: 'SET_SAMPLE_VIEW_FILTER_DATA',
	FETCH_ALL_PHOTOGRAPHY_BY_STATUS: 'FETCH_ALL_PHOTOGRAPHY_BY_STATUS',
	SET_PHOTOGRAPHY_FILTER_DATA: 'SET_PHOTOGRAPHY_FILTER_DATA',
	SET_PHOTOGRAPHY_COUNT: 'SET_PHOTOGRAPHY_COUNT',
	SET_READ_SAMPLE_REQUEST_COMMENT: 'SET_READ_SAMPLE_REQUEST_COMMENT',
	SET_COSTING_FILTER_DATA: 'SET_COSTING_FILTER_DATA',
	SET_COSTING_COUNT: 'SET_COSTING_COUNT',
	CLEAR_SAMPLE_REQUEST: 'CLEAR_SAMPLE_REQUEST',
	CLEAR_PHOTOGRAPHY: 'CLEAR_PHOTOGRAPHY',
	CLEAR_COSTING: 'CLEAR_COSTING',
	FETCH_COSTING_DETAILS: 'FETCH_COSTING_DETAILS',
	FETCH_COSTING_DETAILS_FAILURE: 'FETCH_COSTING_DETAILS_FAILURE',
	FETCH_ALL_QUOTE_REQUEST_BY_STATUS: 'FETCH_ALL_QUOTE_REQUEST_BY_STATUS',
	SET_QUONT_COUNT: 'SET_QUONT_COUNT',
	SET_COSTING_ACTIVE_TAB: 'SET_COSTING_ACTIVE_TAB',
	SET_ACTIVE_COMPLETED_TAB: 'SET_ACTIVE_COMPLETED_TAB',
	SET_BUYER_REQUEST_FILTER_DATA: 'SET_BUYER_REQUEST_FILTER_DATA',
	SET_BUYER_REQUEST_ACTIVE_TAB: 'SET_BUYER_REQUEST_ACTIVE_TAB',
	CLEAR_BUYER_REQUEST: 'CLEAR_BUYER_REQUEST',
	FETCH_MOODBOARD_DETAILS: 'FETCH_MOODBOARD_DETAILS',
	SET_REUPLOADED_MOODBOARD_IMAGE: 'SET_REUPLOADED_MOODBOARD_IMAGE',
	SET_UPLOAD_PRODUCT_IMAGE: 'SET_UPLOAD_PRODUCT_IMAGE',
	REMOVE_PRODUCT_IMAGE_FROM_MOODBOARD: 'REMOVE_PRODUCT_IMAGE_FROM_MOODBOARD',
	ADD_FILE_TO_MOODBOARD: 'ADD_FILE_TO_MOODBOARD',
	ADD_COLOR_TO_MOODBOARD: 'ADD_COLOR_TO_MOODBOARD',
	REMOVE_COLOR_FROM_MOODBOARD: 'REMOVE_COLOR_FROM_MOODBOARD',
	ADD_FABRIC_TO_MOODBOARD: 'ADD_FABRIC_TO_MOODBOARD',
	REMOVE_FABRIC_FROM_MOODBOARD: 'REMOVE_FABRIC_FROM_MOODBOARD',
	ADD_COLORS_FROM_RESPONSE_TO_MOODBOARD: 'ADD_COLORS_FROM_RESPONSE_TO_MOODBOARD',
	ADD_IMAGES_FROM_RESPONSE_TO_MOODBOARD: 'ADD_IMAGES_FROM_RESPONSE_TO_MOODBOARD',
	MOODBOARD_IMAGE_LOADING_START: 'MOODBOARD_IMAGE_LOADING_START',
	MOODBOARD_IMAGE_LOADING_CLOSE: 'MOODBOARD_IMAGE_LOADING_CLOSE',
	MOODBOARD_COLOR_LOADING_START: 'MOODBOARD_COLOR_LOADING_START',
	MOODBOARD_COLOR_LOADING_CLOSE: 'MOODBOARD_COLOR_LOADING_CLOSE',
	MATERIAL_SEARCH_BY_ID: 'MATERIAL_SEARCH_BY_ID',
	NEW_INCOMING_MESSAGE_SUCCESS: 'NEW_INCOMING_MESSAGE_SUCCESS',
	NEW_INCOMING_MESSAGE_FAILURE: 'NEW_INCOMING_MESSAGE_FAILURE',
	SET_CURRENT_ACTIVE_PAGE: 'SET_CURRENT_ACTIVE_PAGE',
	CLEAR_CURRENT_ACTIVE_PAGE: 'CLEAR_CURRENT_ACTIVE_PAGE',
	NEW_INCOMING_MESSAGE_IN_LIST_PAGE: 'NEW_INCOMING_MESSAGE_IN_LIST_PAGE',
	CLEAR_ALL_CHATS: 'CLEAR_ALL_CHATS',
	STORE_TEAM_MEMBER_LIST: 'STORE_TEAM_MEMBER_LIST',
	IS_MY_REQUEST_SELECTED: 'IS_MY_REQUEST_SELECTED',
	IS_TEAM_REQUEST_SELECTED: 'IS_TEAM_REQUEST_SELECTED',
	SELECT_TEAM_MEMBER: 'SELECT_TEAM_MEMBER',
	CLEAR_TEAM_FILTER: 'CLEAR_TEAM_FILTER',
	STORE_ACCOUNT_MANAGER_LIST: 'STORE_ACCOUNT_MANAGER_LIST',
	STORE_MERCHANDISER_LIST: 'STORE_MERCHANDISER_LIST',
	STORE_ORDER_STYLE_LIST: 'STORE_ORDER_STYLE_LIST',
	STORE_ORDER_PO_LIST: 'STORE_ORDER_PO_LIST',
	STORE_ORDER_TITLE_LIST: 'STORE_ORDER_TITLE_LIST',
	STORE_FACTORY_LIST: 'STORE_FACTORY_LIST',
	STORE_SALES_CONTRACT_LIST: 'STORE_SALES_CONTRACT_LIST',
	STORE_COMMERCIAL_INVOICE_LIST: 'STORE_COMMERCIAL_INVOICE_LIST',
	STORE_ORDER_DASHBOARD_TABLE_HEADINGS: 'STORE_ORDER_DASHBOARD_TABLE_HEADINGS',
	TOGGLE_ORDER_DASHBOARD_TABLE_COLUMN: 'TOGGLE_ORDER_DASHBOARD_TABLE_COLUMN',
	TOGGLE_ORDER_DASHBOARD_TABLE_GENERAL_COLUMN: 'TOGGLE_ORDER_DASHBOARD_TABLE_GENERAL_COLUMN',
	TOGGLE_ORDER_DASHBOARD_CRITICAL_COLUMN: 'TOGGLE_ORDER_DASHBOARD_CRITICAL_COLUMN',
	STORE_PROJECT_MANAGER_LIST: 'STORE_PROJECT_MANAGER_LIST',
	FETCH_SUPPLIER_TYPE_WISE_LIST: 'FETCH_SUPPLIER_TYPE_WISE_LIST',
	FETCH_COMPOSITION_LIST: 'FETCH_COMPOSITION_LIST',
	SET_NOTIFICATION_DATA: 'SET_NOTIFICATION_DATA',
	SET_NOTIFICATION_REPLY_COMMENT: 'SET_NOTIFICATION_REPLY_COMMENT',
	FETCH_BRAND_PROFILE_BY_BRAND_ID: 'FETCH_BRAND_PROFILE_BY_BRAND_ID',
	FETCH_GLOBAL_SALES_SUMMARY: 'FETCH_GLOBAL_SALES_SUMMARY',
	FETCH_GLOBAL_ORDER_SUMMARY: 'FETCH_GLOBAL_ORDER_SUMMARY',
	FETCH_COUNTRY_WISE_SALES: 'FETCH_COUNTRY_WISE_SALES',
	FETCH_COLLECTION_WISE_SALES: 'FETCH_COLLECTION_WISE_SALES',
	FETCH_AC_MANAGER_WISE_SALES: 'FETCH_AC_MANAGER_WISE_SALES',
	FETCH_BRAND_WISE_SALES: 'FETCH_BRAND_WISE_SALES',
	FETCH_PRODUCT_GROUP_WISE_SALES: 'FETCH_PRODUCT_GROUP_WISE_SALES',
	FETCH_COUNTRY_WISE_PROJECTION_SUMMARY: 'FETCH_COUNTRY_WISE_PROJECTION_SUMMARY',
	FETCH_COUNTRY_WISE_PROJECTION: 'FETCH_COUNTRY_WISE_PROJECTION',
	FETCH_BDM_WISE_PROJECTION: 'FETCH_BDM_WISE_PROJECTION',
	FETCH_BRAND_WISE_PROJECTION: 'FETCH_BRAND_WISE_PROJECTION',
	COLLAPSE_COUNTRY_WISE_GLOBAL_PROJECTION: 'COLLAPSE_COUNTRY_WISE_GLOBAL_PROJECTION',
	COLLAPSE_BDM_WISE_GLOBAL_PROJECTION: 'COLLAPSE_BDM_WISE_GLOBAL_PROJECTION',
	COLLAPSE_BRAND_WISE_GLOBAL_PROJECTION: 'COLLAPSE_BRAND_WISE_GLOBAL_PROJECTION',
	FETCH_BRAND_WISE_DIRECTOR_PROJECTION_SUMMARY: 'FETCH_BRAND_WISE_DIRECTOR_PROJECTION_SUMMARY',
	FETCH_BRAND_WISE_DIRECTOR_PROJECTION: 'FETCH_BRAND_WISE_DIRECTOR_PROJECTION',
	COLLAPSE_BRAND_WISE_DIRECTOR_PROJECTION: 'COLLAPSE_BRAND_WISE_DIRECTOR_PROJECTION',
	FETCH_BRAND_WISE_SALES_PERFORMANCE: 'FETCH_BRAND_WISE_SALES_PERFORMANCE',
	FETCH_BRAND_WISE_ORDER_SALES_PERFORMANCE: 'FETCH_BRAND_WISE_ORDER_SALES_PERFORMANCE',
	COLLAPSE_BRAND_WISE_SALES_PERFORMANCE: 'COLLAPSE_BRAND_WISE_SALES_PERFORMANCE',
	CHANGE_GLOBAL_PROJECTION_STATUS_BY_PROJECTION_ID: 'CHANGE_GLOBAL_PROJECTION_STATUS_BY_PROJECTION_ID',
	STORE_CRM_BRAND_PROFILE_RELATED_INFO: 'STORE_CRM_BRAND_PROFILE_RELATED_INFO',
	STORE_PROJECTION_CHILD_TAB: 'STORE_PROJECTION_CHILD_TAB',
	SET_TOGGLE_PRICE: 'SET_TOGGLE_PRICE',
	SET_PINNED_COLLECTION: 'SET_PINNED_COLLECTION',
	SET_UNPINNED_COLLECTION: 'SET_UNPINNED_COLLECTION',
	STORE_UNREAD_MENTION: 'STORE_UNREAD_MENTION',
	SET_HAS_MENTIONED_ID: 'SET_HAS_MENTIONED_ID',
	CLEAR_DESIGN_TOOL: 'CLEAR_DESIGN_TOOL',
	SET_CRM_OWN_CONFIGURATION: 'SET_CRM_OWN_CONFIGURATION',
	SET_CRM_LEFT_SIDE_PANEL: 'SET_CRM_LEFT_SIDE_PANEL',
	TOGGLE_CRM_SALES_FUNNEL_SUMMARY: 'TOGGLE_CRM_SALES_FUNNEL_SUMMARY',
	TOGGLE_CRM_VIEW_QUARTER_BTN: 'TOGGLE_CRM_VIEW_QUARTER_BTN',
	TOGGLE_CRM_MONTH_VIEW: 'TOGGLE_CRM_MONTH_VIEW',
	TOGGLE_CRM_EMPTY_STATE: 'TOGGLE_CRM_EMPTY_STATE',
	IS_REQUEST_COMES_FROM_OUTSIDE_OF_CRM: 'IS_REQUEST_COMES_FROM_OUTSIDE_OF_CRM',
	FETCH_YEAR_LIST: 'FETCH_YEAR_LIST',
	SET_BLOCK_ACTION: 'SET_BLOCK_ACTION',
	FETCH_ALL_MEASUREMENT_CATEGORIES: 'FETCH_ALL_MEASUREMENT_CATEGORIES',
	CHANGE_MEASUREMENT_SIZE_CATEGORY_ID: 'CHANGE_MEASUREMENT_SIZE_CATEGORY_ID',
	FETCH_PRODUCT_MEASUREMENT_TABLE_DATA: 'FETCH_PRODUCT_MEASUREMENT_TABLE_DATA',
	SAVE_PRODUCT_MEASUREMENT_TABLE_DATA: 'SAVE_PRODUCT_MEASUREMENT_TABLE_DATA',
	ADD_PRODUCT_MEASUREMENT_CHANGE_LOG: 'ADD_PRODUCT_MEASUREMENT_CHANGE_LOG',
	ADD_PRODUCT_MEASUREMENT_BULK_CHANGE_LOG: 'ADD_PRODUCT_MEASUREMENT_BULK_CHANGE_LOG',
	ADD_NEW_POINT_IN_MEASUREMENT_TABLE: 'ADD_NEW_POINT_IN_MEASUREMENT_TABLE',
	REMOVE_POINT_IN_MEASUREMENT_TABLE: 'REMOVE_POINT_IN_MEASUREMENT_TABLE',
	REMOVE_LIBRARY_POINT_IN_MEASUREMENT_TABLE: 'REMOVE_LIBRARY_POINT_IN_MEASUREMENT_TABLE',
	REPLACE_POM_IN_MEASUREMENT_TABLE: 'REPLACE_POM_IN_MEASUREMENT_TABLE',
	ADD_NEW_SIZE_IN_MEASUREMENT_TABLE: 'ADD_NEW_SIZE_IN_MEASUREMENT_TABLE',
	MODIFY_MEASUREMENT_TABLE_POINT_IDS: 'MODIFY_MEASUREMENT_TABLE_POINT_IDS',
	MODIFY_MEASUREMENT_TABLE_POINT_CODE: 'MODIFY_MEASUREMENT_TABLE_POINT_CODE',
	MODIFY_MEASUREMENT_TABLE_POINT_NAME: 'MODIFY_MEASUREMENT_TABLE_POINT_NAME',
	MODIFY_MEASUREMENT_TABLE_CELL_VALUE: 'MODIFY_MEASUREMENT_TABLE_CELL_VALUE',
	REARRANGE_MEASUREMENT_TABLE_ROW: 'REARRANGE_MEASUREMENT_TABLE_ROW',
	CLEAR_MEASUREMENT_TABLE: 'CLEAR_MEASUREMENT_TABLE',
	CHANGE_MEASUREMENT_GRADING_TYPE: 'CHANGE_MEASUREMENT_GRADING_TYPE',
	MODIFY_MEASUREMENT_TABLE_BULK_SIZE_CELL_VALUE: 'MODIFY_MEASUREMENT_TABLE_BULK_SIZE_CELL_VALUE',
	ADD_MEASUREMENT_GROUP_GRADING: 'ADD_MEASUREMENT_GROUP_GRADING',
	REMOVE_MEASUREMENT_GROUP_GRADING: 'REMOVE_MEASUREMENT_GROUP_GRADING',
	MODIFY_MEASUREMENT_BASE_SIZE: 'MODIFY_MEASUREMENT_BASE_SIZE',
	REMOVE_MEASUREMENT_SIZE: 'REMOVE_MEASUREMENT_SIZE',
	PASTE_MEASUREMENT_SIZE_VALUES: 'PASTE_MEASUREMENT_SIZE_VALUES',
	CLEAR_MEASUREMENT_CHANGE_LOG: 'CLEAR_MEASUREMENT_CHANGE_LOG',
	SET_MEASUREMENT_HISTORY_INFO: 'SET_MEASUREMENT_HISTORY_INFO',
	ADD_MEASUREMENT_SIZE_CATEGORY_SEQUENCE: 'ADD_MEASUREMENT_SIZE_CATEGORY_SEQUENCE',
	SET_DESIGN_VIEW_MODAL_INFO: 'SET_DESIGN_VIEW_MODAL_INFO',
	UPDATE_DESIGN_VIEW_MODAL_INFO: 'UPDATE_DESIGN_VIEW_MODAL_INFO',
	CLEAR_DESIGN_VIEW_MODAL_INFO: 'CLEAR_DESIGN_VIEW_MODAL_INFO',
	STORE_SELECTED_FILTER_CHECK_BOX_TYPE: 'STORE_SELECTED_FILTER_CHECK_BOX_TYPE',
	STORE_IN_MULTI_LEVEL_FILTER: 'STORE_IN_MULTI_LEVEL_FILTER',
	SET_MEASUREMENT_SHOW_COLUMN_VALUE: 'SET_MEASUREMENT_SHOW_COLUMN_VALUE',
	ADD_INIT_MEASUREMENT_ID: 'ADD_INIT_MEASUREMENT_ID',
	STORE_DEPENDENT_FILTER_LIST: 'STORE_DEPENDENT_FILTER_LIST',
	CLEAR_DETAILS_PAGE_GLOBAL_FILTER: 'CLEAR_DETAILS_PAGE_GLOBAL_FILTER',
	UPDATE_MEASUREMENT_TABLE: 'UPDATE_MEASUREMENT_TABLE',
	ADD_CHANGE_LOG_ON_DUPLICATE: 'ADD_CHANGE_LOG_ON_DUPLICATE',
	TOGGLE_BLOCK_SUGGESTIONS_FILTER: 'TOGGLE_BLOCK_SUGGESTIONS_FILTER',
	CONVERT_MEASUREMENT_SIZE_TO: 'CONVERT_MEASUREMENT_SIZE_TO',
	CONVERT_MEASUREMENT_SIZE_CHANGE_LOG: 'CONVERT_MEASUREMENT_SIZE_CHANGE_LOG',
	CONVERT_MEASUREMENT_SIZE_VALUE: 'CONVERT_MEASUREMENT_SIZE_VALUE',
	IS_SHOW_BLOCK_USED_FROM: 'IS_SHOW_BLOCK_USED_FROM',
	HIDE_MEASUREMENT_TABLE_COLUMNS: 'HIDE_MEASUREMENT_TABLE_COLUMNS',
	SHOW_ALL_MEASUREMENT_TABLE_COLUMN: 'SHOW_ALL_MEASUREMENT_TABLE_COLUMN',
	CLEAR_SELECTED_FILTER_NAME: 'CLEAR_SELECTED_FILTER_NAME',
	STORE_BLOCK_PRODUCT_LIST: 'STORE_BLOCK_PRODUCT_LIST',
	TOGGLE_MY_COLLEAGUES_FILTER: 'TOGGLE_MY_COLLEAGUES_FILTER',
	STORE_MY_COLLEAGUES_SEARCH_KEY: 'STORE_MY_COLLEAGUES_SEARCH_KEY',
	SHOW_MY_COLLEAGUES_DETAILS_PAGE: 'SHOW_MY_COLLEAGUES_DETAILS_PAGE',
	UPDATE_IN_MULTI_LEVEL_FILTER: 'UPDATE_IN_MULTI_LEVEL_FILTER',
	FETCH_PRICE_RANGE_TABLE_DATA_BY_BRAND_ID: 'FETCH_PRICE_RANGE_TABLE_DATA_BY_BRAND_ID',
	FETCH_PROFIT_MARGIN_TABLE_DATA_BY_BRAND_ID: 'FETCH_PROFIT_MARGIN_TABLE_DATA_BY_BRAND_ID',
	SAVE_SUPPLIER_ONBOARDING_STATUS: 'SAVE_SUPPLIER_ONBOARDING_STATUS',
	SAVE_SUPPLIER_INFORMATION: 'SAVE_SUPPLIER_INFORMATION',
	SAVE_SUPPLIER_BANK_INFORMATION: 'SAVE_SUPPLIER_BANK_INFORMATION',
	SAVE_SUPPLIER_DOCUMENTS: 'SAVE_SUPPLIER_DOCUMENTS',
	PRODUCT_CRM_IDS_STATE: 'PRODUCT_CRM_IDS_STATE',
	SAVE_TREND_RESEARCH_USER_PREFERENCE: 'SAVE_TREND_RESEARCH_USER_PREFERENCE',
	SET_SELECTED_PREFERENCE_FOR_FILTER: 'SET_SELECTED_PREFERENCE_FOR_FILTER',
	SET_DEFAULT_SELECTED_PREFERENCE_FOR_FILTER: 'SET_DEFAULT_SELECTED_PREFERENCE_FOR_FILTER',
	SET_SELECTED_BRANDS_FOR_FILTER: 'SET_SELECTED_BRANDS_FOR_FILTER',
	SET_MULTIPLE_SELECTED_BRANDS_FOR_FILTER: 'SET_MULTIPLE_SELECTED_BRANDS_FOR_FILTER',
	SET_ALL_BRANDS_FOR_FILTER: 'SET_ALL_BRANDS_FOR_FILTER',
	SET_ALL_TREND_RESEARCH_BRAND_LIST: 'SET_ALL_TREND_RESEARCH_BRAND_LIST',
	SET_BRAND_INSIGHT_SUMMARY: 'SET_BRAND_INSIGHT_SUMMARY',
	SET_EXPLORE_PRODUCTS_SOURCE_TYPE: 'SET_EXPLORE_PRODUCTS_SOURCE_TYPE',
	SET_ALL_INSTAGRAM_INFLUENCER: 'SET_ALL_INSTAGRAM_INFLUENCER',
	SELECT_ALL_INSTAGRAM_INFLUENCER: 'SELECT_ALL_INSTAGRAM_INFLUENCER',
	TOGGLE_INSTAGRAM_INFLUENCER: 'TOGGLE_INSTAGRAM_INFLUENCER',
	SET_SINGLE_MOODBOARD: 'SET_SINGLE_MOODBOARD',
	SET_TREND_RESEARCH_FILTER_CALENDAR: 'SET_TREND_RESEARCH_FILTER_CALENDAR',
	TOGGLE_BOTH_MARKET_AND_FABRIC_TYPES: 'TOGGLE_BOTH_MARKET_AND_FABRIC_TYPES',
	SET_ALL_MOODBOARD: 'SET_ALL_MOODBOARD',
	SET_ACTIVE_TAB_INFO: 'SET_ACTIVE_TAB_INFO',
	UPDATE_COSTING_ITEM_INFO: 'UPDATE_COSTING_ITEM_INFO'
};
